import { minimalInputTheme } from '@/app/theme';
import { usePipelineContext } from '@/context/pipelineContext';
import { Autocomplete, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useMemo } from 'react';

const PipelineSelect = ({
	name,
	value,
	disabled,
	onChange,
	minimal = false,
	error = false,
	hideProspectStage = false,
}) => {

	const { pipelines } = usePipelineContext();
	const filteredPipelines = useMemo(() => {
		if (!hideProspectStage) return pipelines;
		return pipelines.filter((pipeline) => {
			const pipelineName = pipeline?.label ?? pipeline?.pipelineName ?? '';
			return pipelineName.toLowerCase() !== 'prospects';
		});
	}, [pipelines, hideProspectStage]);

	const selectedPipeline = filteredPipelines.find((p) => p.id === value);

	useEffect(() => console.log('Pipelines in PipelineSelect', pipelines), [pipelines]);

	return (
		<Autocomplete
			id={name}
			name={name}
			fullWidth
			disabled={disabled}
			isOptionEqualToValue={(option, val) => option?.id === val?.id}
			getOptionLabel={(option) => option?.label ?? option?.name ?? ''}
			options={filteredPipelines}
			value={selectedPipeline}
			inputValue={selectedPipeline?.label ?? ''}
			filterOptions={(options) => options}
			disableClearable
			onChange={(_, option) => onChange?.(option?.id)}
			renderOption={(props, option) => {
				return (
					<li
						{...props}
						style={{ width: '100%' }}
						key={`pipeline-selection-${option?.id}`}
					>
						{option?.label}
					</li>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					variant={minimal ? 'standard' : 'outlined'}
					error={error}
					onKeyDown={(e) => {
						e.preventDefault();
					}}
					slotProps={{
						input: {
							...params.InputProps,
							readOnly: true,

							style: {
								caretColor: 'transparent',
								cursor: 'pointer',
								...(minimal && {
									...(disabled && { backgroundColor: 'transparent' }),
								}),
							},
						},
					}}
					sx={(theme) => ({
						...(minimal && {
							...minimalInputTheme,
							'& .Mui-disabled': {
								backgroundColor: 'transparent',
							},
						}),
						'& .MuiInput-input': {
							color: theme.palette.primary.main,
						},
						cursor: 'pointer',
					})}
				/>
			)}
			sx={{
				cursor: 'pointer',
				'& .MuiInputBase-root': {
					cursor: 'pointer',
				},
				'& input': {
					cursor: 'pointer',
				},
				...(minimal && {
					...minimalInputTheme,
					'& .Mui-disabled': {
						backgroundColor: 'transparent',
					},
					'& .MuiInputBase-root': {
						backgroundColor: 'transparent',
					},
				}),
			}}
		/>
	);
};
export default PipelineSelect;
